import React from 'react';
import { NSLoadingScreen } from '../../bricks';

interface IRenderIf<T> {
    isLoading?: boolean;
    loadingMessage?: string;
    isTrue: T;
    children: React.ReactNode;
    shouldLoadAiLogo?: boolean;
}

const RenderIf = <T,>({
    isLoading = false, loadingMessage = '', isTrue, children,
    shouldLoadAiLogo = false,
}: IRenderIf<T>) => {
    if (isLoading) {
        return <NSLoadingScreen message={loadingMessage} shouldLoadAiLogo={shouldLoadAiLogo} />;
    }

     
    return isTrue ? <>{children}</> : null; 
};

export default RenderIf;
